export default __webpack_public_path__ + "static/media/masters.7d99cd64.png";